import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import Form from './Form';
import FormDeudor from './FormDeudor';
import FormInversionista from './FormInversionista';
import NonStretchImage from '../NonStretchedImage/NonStretchedImage';

type formType = 'default' | 'deudor' | 'inversionista';

interface Props {
  type?: formType;
}


const Contact = (props: Props) => {
  const { type = 'default' } = props;

  const result = useStaticQuery(
    graphql`
      {
        file(relativePath: { eq: "building.png" }) {
          childImageSharp {
            fluid(quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
              presentationWidth
            }
          }
        }
      }
    `
  )

  return (
    <section className="relative" style={{ height: '850px' }}>
      <NonStretchImage
        fluid={result.file.childImageSharp.fluid}
        alt="Edificio"
        className="block w-full h-full object-cover"
      />
      {type === 'default' && <Form />}
      {type === 'inversionista' && <FormInversionista />}
      {type === 'deudor' && <FormDeudor />}
    </section>
  );
};

export default Contact;
